<template>
    <div class="rejected-list">
      <!-- 搜索和筛选 -->
      <el-form :inline="true" class="search-form" size="small">
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.workName"
            placeholder="搜索项目名称"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item label="申请人">
          <el-input
            v-model="searchForm.applyUser"
            placeholder="搜索申请人ID"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item label="审批人">
          <el-input
            v-model="searchForm.reviewUser"
            placeholder="搜索审批人ID"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">
            搜索
          </el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
  
      <!-- 申请列表 -->
      <el-table
        :data="applyList"
        border
        v-loading="loading"
        class="apply-table"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="id" label="申请ID" width="80" sortable="custom" />
        <el-table-column prop="WorkName" label="项目名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="build_company" label="建设单位" min-width="120" show-overflow-tooltip />
        <el-table-column label="修改内容" min-width="100">
          <template slot-scope="scope">
            <el-tag size="small" type="info">
              修改{{ scope.row.changedCount || 0 }}项
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyUserName" label="申请人" width="100">
          <template slot-scope="scope">
            {{ scope.row.applyUserName || '用户' + scope.row.apply_user_id }}
          </template>
        </el-table-column>
        <el-table-column prop="apply_time" label="申请时间" width="150" sortable="custom">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.apply_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="reviewUserName" label="审批人" width="100">
          <template slot-scope="scope">
            {{ scope.row.reviewUserName || (scope.row.review_user_id ? '用户' + scope.row.review_user_id : '-') }}
          </template>
        </el-table-column>
        <el-table-column prop="review_time" label="审批时间" width="150">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.review_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="review_remark" label="拒绝理由" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="reject-reason">
              {{ scope.row.review_remark || '未填写理由' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" :width="(roleId == 1 || roleId == '1') ? '120' : '180'" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        class="pagination"
      />
  
    </div>
  </template>
  
  <script>
  import { getContractApplyList } from '../api';
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'RejectedList',
    
    data() {
      return {
        loading: false,
        applyList: [],
        
        // 搜索表单
        searchForm: {
          workName: '',
          applyUser: '',
          reviewUser: ''
        },
        
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        
        // 排序
        sortField: 'review_time',
        sortOrder: 'desc',
        
      };
    },
    
    computed: {
      ...mapGetters(['roleId'])
    },
    
    created() {
      this.loadData();
    },
    
    methods: {
      // 加载数据
      async loadData() {
        this.loading = true;
        try {
          const params = {
            page: this.pagination.current,
            limit: this.pagination.size,
            status: 2, // 已拒绝状态
            roleId: this.roleId // 传递角色ID
          };
          
          // 添加搜索条件
          if (this.searchForm.workName) {
            params.workName = this.searchForm.workName;
          }
          if (this.searchForm.applyUser) {
            params.applyUser = this.searchForm.applyUser;
          }
          if (this.searchForm.reviewUser) {
            params.reviewUser = this.searchForm.reviewUser;
          }
          
          // 添加排序
          if (this.sortField) {
            params.field = this.sortField;
            params.order = this.sortOrder;
          }
          
          const res = await getContractApplyList(params);
          
          if (res.code === 0) {
            this.applyList = res.data || [];
            this.pagination.total = res.count || 0;
          } else {
            this.$message.error(res.msg || '加载失败');
          }
        } catch (error) {
          console.error('加载已拒绝列表失败:', error);
          this.$message.error('加载失败');
        } finally {
          this.loading = false;
        }
      },
      
      // 搜索
      handleSearch() {
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 重置搜索
      resetSearch() {
        this.searchForm = {
          workName: '',
          applyUser: '',
          reviewUser: ''
        };
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 排序变化
      handleSortChange({ prop, order }) {
        if (prop && order) {
          this.sortField = prop;
          this.sortOrder = order === 'ascending' ? 'asc' : 'desc';
        } else {
          this.sortField = 'review_time';
          this.sortOrder = 'desc';
        }
        this.loadData();
      },
      
      // 分页大小变化
      handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 当前页变化
      handleCurrentChange(current) {
        this.pagination.current = current;
        this.loadData();
      },
      
      // 查看详情
      handleViewDetail(row) {
        this.$emit('show-detail', {
          applyId: row.id,
          canApprove: false,
        });
      },
      
      // 重新申请
      handleReApply(row) {
        // 跳转到申请页面，传递合同ID
        this.$router.push({
          path: '/yj/contract/apply',
          query: { 
            contractId: row.contract_id
          }
        });
      },
      
      // 格式化日期时间
      formatDateTime(datetime) {
        if (!datetime) return '-';
        const date = new Date(datetime);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      }
    }
  };
  </script>
  
  <style scoped>
  .rejected-list {
    padding: 10px;
  }
  
  .search-form {
    margin-bottom: 15px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  
  .apply-table {
    margin-bottom: 15px;
    font-size: 13px;
  }
  
  .pagination {
    text-align: right;
    padding: 10px 0;
  }
  
  .reject-reason {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1.4;
    max-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  
  .dialog-footer {
    text-align: right;
  }
  
  /* 响应式适配 */
  @media screen and (max-width: 768px) {
    .search-form {
      padding: 10px;
    }
    
    .apply-table {
      font-size: 12px;
    }
    
    ::v-deep .el-table__cell {
      padding: 4px 0;
    }
    
    ::v-deep .el-button--mini {
      padding: 4px 8px;
      font-size: 12px;
    }
    
    .reject-reason {
      -webkit-line-clamp: 2;
      font-size: 11px;
    }
  }
  </style>